export default __webpack_public_path__ + "d40fb2dd5c9e97bfb65aad8ece4dbad5.jpg";